import { ADMIN_CENTER_DATA } from '@routes/sidebar/___shared___/api/constants.ts';

import type { PathwaySectionRequest } from './api/creatorPathways.api';

export const BASE_SECTIONS_PAYLOAD: PathwaySectionRequest[] = [
    {
        id: 0,
        parentSectionId: null,
        adminPathwaySectionId: null,
        subSections: [],
        sectionName: 'Section 1',
        sectionOrder: 0,
        elements: [],
    },
];

export const TAGGING_DATA_PAYLOAD = {
    dataToReturn: [
        ADMIN_CENTER_DATA.VESSEL_GROUPS,
        ADMIN_CENTER_DATA.VESSELS,
        ADMIN_CENTER_DATA.VESSEL_SUB_TYPES,
        ADMIN_CENTER_DATA.VESSEL_DEPARTMENTS,
        ADMIN_CENTER_DATA.PROFICIENCY_LEVELS,
        ADMIN_CENTER_DATA.RANK_SETS_WITH_REFERENCE,
    ],
};

export const CERTIFICATE_PREVIEW_DRAFT_PARAM = 'draft';
